<template>
  <basicContainer>
    <div class="submitresult" ref="submitresult" >
      <div class="success-icon-wrapper">
        <i class="fa fa-check-circle fa-5x success-icon" ></i>
      </div>
      <div class="tips">提交成功</div>
      <div class="sub-tips">{{submitSuccessPrompt}}</div>

     <template v-if="buttonControl.nextProcess">
        <el-button type="success" size="small" @click="nextProcess">继续办理</el-button>
        <span>&nbsp; &nbsp; &nbsp;</span>
     </template>
      <template v-if="buttonControl.nextLink">
        <el-button type="success" size="small"  @click="nextProcess">下一步 ({{ buttonControl.row.taskName}})</el-button>
        <span>&nbsp; &nbsp; &nbsp;</span>
      </template>
      <template v-if="buttonControl.havaMyTodo && this.$route.query.isIframe !== 'true'">
        <el-button type="defult" size="small" @click="$router.push('/TaskFlow/index')">我的待办</el-button>
      <span>&nbsp; &nbsp; &nbsp;</span>
      </template>

      <el-button v-if="this.$route.query.isIframe !== 'true'" type="info" size="small" @click="$router.push('/')">返回主页</el-button>
      <span v-if="this.$route.query.isIframe !== 'true'">&nbsp; &nbsp; &nbsp;</span>
      <el-button v-if="processInstanceId && businessKey" type="primary" size="small" @click="viewDetails">查看详情</el-button>
    </div>
  </basicContainer>
</template>

<script>
export default {
  data() {
    return {
      submitSuccessPrompt: '信息已提交并保存',
      businessKey: null,
      processInstanceId: '',
      buttonControl: {
        nextProcess: false,
        nextLink: false,
        havaMyTodo: true,
        row: {}
      }
    }
  },
  mounted() {
    let { processInstanceId, businessKey, submitSuccessPrompt } = this.$route.query
    this.processInstanceId = processInstanceId
    this.businessKey = businessKey
    if (submitSuccessPrompt) {
      this.submitSuccessPrompt = submitSuccessPrompt
    }
    if (processInstanceId) {
      this.$http.get('/flow-ext/my-todo-and-wait-me-claim', { params: { pageNum: 1, pageSize: 1 }}).then(response => {
        if (response.data.records && response.data.records.length >= 1) {
          if (response.data.records[0].processInstanceId === processInstanceId) {
          // 下一个环境与当前环境执行人相同   下一环节,返回主页,查看详情
            this.buttonControl.row = response.data.records[0]
            this.buttonControl.nextLink = true
          } else {
          // 下一个环境与当前环境执行人不同   下一流程,返回主页,查看详情
            this.buttonControl.nextProcess = true
            this.buttonControl.row = response.data.records[0]
          }
        } else {
          this.buttonControl.havaMyTodo = false
        }
      // 没有代办任务了, 返回主页, 查看详情
      }).catch(error => console.error(error.msg || error.message))
    }
  },
  methods: {
    // 查看详情
    viewDetails() {
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: this.businessKey,
          processInstanceId: this.processInstanceId,
          taskId: null,
          formId: null,
          pageKey: 'VIEW',
          isIframe: this.$route.query.isIframe
        }
      })
    },
    // 下一流程
    nextProcess() {
      this.$router.push({
        name: 'workFlow-view-myApply',
        query: {
          businessKey: this.buttonControl.row.businessKey,
          processInstanceId: this.buttonControl.row.processInstanceId,
          taskId: this.buttonControl.row.taskId,
          formId: this.buttonControl.row.taskFormKey[0],
          pageKey: 'DO',
          isIframe: this.$route.query.isIframe
        }
      })
    }

  }
}
</script>
<style lang="scss" scoped>
.submitresult {
  padding: 100px 0;
  display: block;
  text-align: center;
  background: #fff;
}
.submitresult .success-icon-wrapper .success-icon {
  color: #66bc5c;
  font-size: 70px;
}

.submitresult .tips {
  font-size: 26px;
  margin-bottom: 10px;
  font-family: PingFangSC-Regular;
  color: rgba(31, 56, 88, 0.8);
}
.submitresult .sub-tips {
  margin-bottom: 32px;
  color: rgba(0, 0, 0, 0.4);
}

</style>
